import { render } from "./CustomBankStatement.vue?vue&type=template&id=090df51e"
import script from "./CustomBankStatement.vue?vue&type=script&lang=js"
export * from "./CustomBankStatement.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__